import React, { ReactNode } from 'react';

// Define the structure of the form data

export interface RegistrationFormData {
  name: string;
  email: string;
  phoneNumber: string;
  businessName: string;
  businessAddress: string;
  vistarAccountNumber?: string; // Optional fields indicated by ?
  vendorSupplyAccountNumber?: string;
  stacyWilliamsAccountNumber?: string;
  petesCoffeeDirectAccountNumber?: string;
  nespressoDirectAccountNumber?: string;
  keurigDirectAccountNumber?: string;
  contractName: string;
  contractTitle: string;
  action: string;

}

export interface ContactFormData {
    firstName: string;
    lastName: string;
    businessName?: string;
    email: string;
    phoneNumber?: string;
    message: string;
    action: string;

}

export interface AcceptedTerms {
    acceptTerms: boolean;
    updateTerms: (acceptTerms: boolean) => void;
}

export interface ShowModalData {
    show: boolean;
    updateShow: (show: boolean) => void;
}

export type AccordionData = {
    title: string;
    content: ReactNode;
};

export interface acceptedTerms{}

/**
 * Simulates submitting the registration form data to a backend API.
 * @param formData The data collected from the form.
 * @param recaptchaToken The token generated by reCAPTCHA.
 * @returns A promise that resolves to a success message or rejects with an error.
 */
export const submitRegistration = async (
  formData: RegistrationFormData,
  recaptchaToken: string | null
): Promise<{ success: boolean; message: string }> => {
      console.log('Submitting registration:', formData);
      console.log('reCAPTCHA token:', recaptchaToken);

      if (!recaptchaToken) {
        console.error('reCAPTCHA token is missing.');
        return {
          success: false,
          message: 'reCAPTCHA verification failed. Please try again.',
        };
      }

      // Simulate network delay
      await new Promise(resolve => setTimeout(resolve, 1000));

      // In a real application, you would make an API call here:
      try {
            const response = await fetch('https://n4gucj4keh.execute-api.us-east-1.amazonaws.com/development/vending-rebates', {
                  method: 'POST',
                  body: JSON.stringify(formData),
            });
            console.log(response);
            if (!response.ok) {
                throw new Error('API submission failed');
            }
            const result = await response.json();
            return { success: true, message: result.message || 'Registration successful!' };
      } catch (error) {
            console.error('API submission error:', error);
            return { success: false, message: 'Submission failed. Please try again later.' };
      }
};

export const submitContact = async (
    formData: ContactFormData,
    recaptchaToken: string | null
): Promise<{ success: boolean; message: string }> => {
    // console.log('Submitting registration:', formData);
    // console.log('reCAPTCHA token:', recaptchaToken);

    if (!recaptchaToken) {
        console.error('reCAPTCHA token is missing.');
        return {
            success: false,
            message: 'reCAPTCHA verification failed. Please try again.',
        };
    }

    // Simulate network delay
    // await new Promise(resolve => setTimeout(resolve, 1000));

    // In a real application, you would make an API call here:
    try {
        const response = await fetch('https://n4gucj4keh.execute-api.us-east-1.amazonaws.com/development/vending-rebates', {
            method: 'POST',
            body: JSON.stringify(formData),
        });
        console.log(response);
        if (!response.ok) {
            throw new Error('Contact Form Submission failed');
        }
        const result = await response.json();
        return { success: true, message: result.message || 'Contact Request Sent' };
    } catch (error) {
        console.error('API submission error:', error);
        return { success: false, message: 'Contact Form Submission failed. Please try again later.' };
    }
};
